howspace.activityTracker = (() => {
    'use strict';

    const IDLE_TIMEOUT_MS = 1000 * 60 * 10; // 10 minutes

    let isIdle = false;
    let isPlaybackActive = false;
    let isInMeeting = false;
    let isRecording = false;
    let isAdminApp = document.body.classList.contains('admin');
    let timeoutId = null;

    // Any of these events indicate user activity and reset the idle timeout.
    document.addEventListener('scroll', resetIdleTimeout, {capture: true, passive: true});
    document.addEventListener('pointermove', resetIdleTimeout, {capture: true});
    document.addEventListener('pointerdown', resetIdleTimeout, {capture: true});
    document.addEventListener('keydown', resetIdleTimeout, {capture: true});

    function disconnect() {
        // Remove reset idle timeout listeners.
        document.removeEventListener('scroll', resetIdleTimeout, {capture: true});
        document.removeEventListener('pointermove', resetIdleTimeout, {capture: true});
        document.removeEventListener('pointerdown', resetIdleTimeout, {capture: true});
        document.removeEventListener('keydown', resetIdleTimeout, {capture: true});

        // Prevent uploading files with paste or drag-and-drop while being idle.
        document.addEventListener('paste', preventFileUpload, {capture: true});
        document.addEventListener('drop', preventFileUpload, {capture: true});

        isIdle = true;
        real.visit.stop();
        real.realtime.uwebsocket.disconnect();
        real.window.reloadPageOrNotifyUser(howspace.translate('layout_disconnected_due_to_inactivity'));

        // Disable all primary and secondary buttons.
        $('.btn-primary, .btn-secondary').prop('disabled', true);

        // Disable AI chat input because it uses custom controls outside the common button classes.
        $('.howspace-ai-chat-send, .howspace-ai-chat-input').prop('disabled', true);

        // Disable all tertiary buttons except cancel buttons and buttons that toggle a dropdown or close modals.
        $('.btn-tertiary:not(.cancel-btn, .cancel-widget-btn, [data-close-modal="true"], [data-toggle="dropdown"])').prop('disabled', true);
    }

    function preventFileUpload(e) {
        let files = e.dataTransfer?.files ?? [];
        if (files.length === 0) {
            const items = e.clipboardData?.items ?? [];
            for (const item of items) {
                if (item.kind === 'file') {
                    files.push(item);
                }
            }
        }
        if (files.length > 0) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    function isActive() {
        if (isPlaybackActive) {
            return true;
        }
        if (isInMeeting) {
            return true;
        }
        if (isRecording) {
            return true;
        }
        if (isAdminApp) {
            return true;
        }
        return false;
    }

    function resetIdleTimeout() {
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
        }
        if (!isActive()) {
            timeoutId = setTimeout(disconnect, IDLE_TIMEOUT_MS);
        }
    }

    if (real.dom.$body.hasClass('live-active')) {
        isInMeeting = true;
    }

    resetIdleTimeout();

    return {
        isIdle: () => {
            return isIdle;
        },
        resetIdleTimeout: resetIdleTimeout,
        setPlaybackActive: (flag) => {
            isPlaybackActive = flag;
            resetIdleTimeout();
        },
        setInMeeting: (flag) => {
            isInMeeting = flag;
            resetIdleTimeout();
        },
        setRecording: (flag) => {
            isRecording = flag;
            resetIdleTimeout();
        },
    };
})();
